import React from 'react';
import * as Icons from 'lucide-react';
import { Asterisk } from 'lucide-react';
import { methodology } from '../data/mock';

const Methodology = () => {
  return (
    <section id="method" className="relative py-20 lg:py-28 bg-[#0A0E1A] text-white overflow-hidden">
      <div className="absolute top-1/2 -translate-y-1/2 -right-40 w-[500px] h-[500px] rounded-full bg-[#C41E3A]/15 blur-3xl blob" />
      <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-[#C41E3A]/10 blur-3xl blob" style={{ animationDelay: '3s' }} />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          <div>
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#F87171] mb-4">
              <Asterisk className="w-4 h-4" />
              How We Work
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold leading-[1.05]">
              A structured path to compliance
            </h2>
          </div>
          <div className="lg:pt-12">
            <p className="text-white/70 text-base md:text-lg leading-relaxed">
              Every mandate is different — the path is not. Five deliberate stages that turn a regulatory requirement into an approved product, then keep it that way.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
          {methodology.map((m, i) => {
            const Icon = Icons[m.icon] || Icons.Circle;
            return (
              <div
                key={m.step}
                className="lift relative bg-white/[0.04] backdrop-blur border border-white/10 rounded-[1.75rem] p-6 pb-8 hover:bg-white/[0.08] hover:border-[#C41E3A]/50 transition-all"
              >
                {/* Step ribbon */}
                <div className="absolute -top-3 left-6 px-3 h-7 rounded-full bg-[#C41E3A] text-white text-[11px] font-mono flex items-center">
                  Step {m.step}
                </div>
                <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/10 flex items-center justify-center mt-4 mb-6">
                  <Icon className="w-6 h-6 text-[#F87171]" />
                </div>
                <h3 className="font-display text-xl font-bold mb-2 leading-tight">{m.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{m.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Methodology;
